const currentDomain = window.location.hostname;
const isOrionaiot = currentDomain.toLowerCase().includes("orionaiot");
const themeName = isOrionaiot ? "purple" : "blue";

// Cargar el tema dinámicamente
if (isOrionaiot) {
    import("./purple.css");
} else {
    import("./blue.css");
}

// Establecer el atributo data-theme en el body
document.body.setAttribute("data-theme", themeName);

export default themeName;
